import * as React from 'react';

/**
 * Permite reasignar múltiples referencias desde un mismo componente.
 *
 * @example
 *
 * const ref1 = useRef(null)
 * const ref2 = useRef(null)
 *
 * const assignRefs = useMultipleRefs(ref1, ref2);
 *
 * return <Box ref={assignRefs} ...
 */
export function useCombinedRefs<RefType = HTMLInputElement>(
  ...refs: (React.ForwardedRef<unknown> | undefined)[]
) {
  const [targetRef, setTargetRef] = React.useState<RefType>();

  React.useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef);
      } else {
        // eslint-disable-next-line no-param-reassign
        ref.current = targetRef;
      }
    });
  }, [refs, targetRef]);

  return setTargetRef;
}
